module.exports = __webpack_public_path__ + "img/home-luxury-arrival-banner.b80f0f56.png";